import { Button } from '@heroui/react'
import React, { useState } from 'react'

function NewsCard({ img, date, title, id }) {

    // scale down the img on hover the card
    const [hover, setHover] = useState(false);

    const handleHover = () => {
        setHover(!hover);
    }


    return (
        <div className=' relative w-full bg-red-500 aspect-square rounded-2xl overflow-clip' onMouseEnter={handleHover} onMouseLeave={handleHover}>
            {/* overlay */}
            <div className='absolute top-0 left-0 w-full h-full bg-gradient-to-t from-[#12CAD280] bg-opacity-50 rounded-2xl'></div>
            {/* bg img */}
            <img src={img} alt='news' className='w-full h-full object-cover rounded-2xl' />
            {/* content */}

            <div className='absolute bottom-0 left-0 p-4'>
                <h1 className='text-white text-xl font-bold'>{date}</h1>
                <p className='text-white text-sm mt-2'>{title}</p>
                <hr className='my-4' />
                <Button className='bg-transparent text-white' auto onPress={
                    () => {
                        window.location.href = `/blog-detailed?id=${id}`
                    }
                }>View</Button>
            </div>
        </div>
    )
}

export default NewsCard